import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="auth-loading">로그인 상태를 확인하는 중...</div>;
  }

  if (user?.role !== 'ADMIN') {
    return <Navigate to="/posts" replace />;
  }

  return children;
}

export default AdminRoute;
